import { useQuery } from '@tanstack/react-query';
import { fetchEpicCounts } from '../../api/projects';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';

export const epicCountsQueryKey = (fiscalYearQuarters: string[]) =>
  ['epicCounts', fiscalYearQuarters] as const;

export function useEpicCounts(fiscalYearQuarters: string[]) {
  const { apiUrl } = useProductSettings<Settings>();

  return useQuery({
    queryKey: epicCountsQueryKey(fiscalYearQuarters),
    queryFn: () => fetchEpicCounts(apiUrl, fiscalYearQuarters),
    enabled: fiscalYearQuarters.length > 0,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: 30 * 60 * 1000,
  });
}
